import api from './authService';

export const adminSystemMessagesService = {
  // Get all admin system messages
  getAll: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/admin/system-messages${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  // Get statistics
  getStatistics: async () => {
    const response = await api.get('/admin/system-messages/statistics');
    return response.data;
  },

  // Get single message
  getOne: async (id) => {
    const response = await api.get(`/admin/system-messages/${id}`);
    return response.data;
  },

  // Mark as read
  markAsRead: async (id) => {
    const response = await api.patch(`/admin/system-messages/${id}/mark-read`);
    return response.data;
  },

  // Mark all as read
  markAllAsRead: async () => {
    const response = await api.patch('/admin/system-messages/mark-all-read');
    return response.data;
  },

  // Delete message
  delete: async (id) => {
    const response = await api.delete(`/admin/system-messages/${id}`);
    return response.data;
  },
};

